// import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';

// interface BreadCrumbProps {
//     moduleName: string;
//     pageName?: string;
//     viewName?: string;
// }

// const BreadCrumb: React.FC<BreadCrumbProps> = ({
//     moduleName, pageName, viewName
// }) => {
//     const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
//         const stored = localStorage.getItem('sidebarOpen');
//         return stored === null ? true : stored === 'true';
//     });

//     useEffect(() => {
//         const handleSidebarToggle = () => {
//             const stored = localStorage.getItem('sidebarOpen');
//             setIsSidebarOpen(stored === 'true');
//         };

//         window.addEventListener('sidebarToggle', handleSidebarToggle);
        
//         return () => {
//             window.removeEventListener('sidebarToggle', handleSidebarToggle);
//         };
//     }, []);

//     const generateBreadcrumbLink = () => {
//         switch (moduleName) {
//             case "Dataset":
//                 return '/Datalist';
//             case "Training":
//                 return '/TrainingModal';
//             case "Template":
//                 return '/TemplateList';
//             case "Dashboard":
//                 return "/test";
//             default:
//                 return "/";
//         }
//     }

//     return (
//         <header
//             className={`bg-white shadow-[0_3px_3px_#38414a1a] fixed top-[65px] left-0 right-0 pt-3 pb-2 z-[9]
//                  transition-all duration-300 border-t border-t-[#E9EBEC] border-b-[3px] border-b-[#FD7545]
//                  ${isSidebarOpen ? 'ml-[230px]' : 'ml-[70px]'}`}
//         >
//             <div className="flex items-center justify-between px-6 w-full">

//                 {/* LEFT: Module name */}
//                 <div className="flex items-center">
//                     {generateBreadcrumbLink() !== "" ? (
//                         <Link
//                             className="hidden sm:inline breadcrumb-text font-bold text-base uppercase text-[#fd7545] font-sans"
//                             to={generateBreadcrumbLink()}
//                         >
//                             {moduleName}
//                         </Link>
//                     ) : (
//                         <span className="hidden sm:inline breadcrumb-text font-bold text-base uppercase text-[#fd7545] font-sans">
//                             {moduleName}
//                         </span>
//                     )}
//                 </div>

//                 {/* RIGHT: Page > View */}
//                 <div className="flex items-center font-sans text-sm">
//                     {pageName && (
//                         <span className="hidden sm:inline">
//                             {pageName}
//                         </span>
//                     )}

//                     {pageName && viewName && (
//                         <span className="mx-2 hidden sm:inline">&gt;</span>
//                     )}

//                     {viewName && (
//                         <span className="hidden sm:inline text-gray-500">
//                             {viewName}
//                         </span>
//                     )}
//                 </div>

//             </div>
//         </header>
//     )
// }

// export default BreadCrumb;
import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

const BreadCrumb = ({ moduleName, pageName, viewName }) => {
    const roleName = localStorage.getItem("roleName")
        const generateBreadcrumbLink = (moduleName) => {
        switch (moduleName) {
            case "Dataset":
                return '/Datalist';
            case "Training":
                return '/TrainingModal';
            case "Template":
                return '/TemplateList';
            case "Dashboard":
                return "/test";
            default:
                return "/";
        }
    }
    return (
        <React.Fragment>
            <Row>
                <Col xs={12}>
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between rv-breadcrumb-border">
                        <h4 className="mb-sm-0 rv-text-primary-color">
                        {generateBreadcrumbLink(moduleName) !== "" ?
                                        <Link to={generateBreadcrumbLink(moduleName)}>
                                            {moduleName ? moduleName : pageName}
                                        </Link>
                                        : <>{moduleName? moduleName : pageName}</>
                                    }
                        </h4> 
                        {roleName !== "Customer" && <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item">
                                    {pageName}
                                </li>
                                <li className="breadcrumb-item active" >{viewName}</li>
                            </ol>
                        </div>}

                    </div>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default BreadCrumb;